export default function Copyright() {
  return (
    <p className="text-sm m-0 text-greyscale-placeholder text-center">
      © {new Date().getFullYear()} Winelivery Srl, all rights reserved. • p.i.:
      00985770148 • sede legale: Via Maurizio Gonzaga 5 Milano 20123 • capitale
      sociale: 56.878,79€ • numero rea: MI - 2077996
    </p>
  );
}
